var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#FFCD00",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    color: "#FFCD00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "codeAltIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L3 12L7 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16L21 12L17 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5L14.5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeAlt);
export default __webpack_public_path__ + "static/media/code-alt.89a98c7fd6fc64f69bd38f9b7d84979f.svg";
export { ForwardRef as ReactComponent };